/*global define*/
import FeGeometryCreator from "../Core/FeGeometryCreator.js";

function createFeGeometry(feGeometry, offset) {
  return FeGeometryCreator.createGeometry(feGeometry);
};
export default createFeGeometry;